import { FormlyFieldConfig } from '@ngx-formly/core';
import { ValidationMessageOption } from '@ngx-formly/core/lib/models';
import { TranslateService } from '@ngx-translate/core';
import { switchMap } from 'rxjs';

export function formValidationConfig(translate: TranslateService) {
  return {
    validationMessages: [
      {
        name: 'phoneNumber',
        message() {
          return 'Số điện thoại không hợp lệ';
        },
      },
      {
        name: 'email',
        message() {
          return 'Email không hợp lệ';
        },
      },
      {
        name: 'length',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream('FORM.VALIDATION.INVALID_LENGTH', {
            field: field.formControl?.value,
          });
        },
      },
      {
        name: 'passwordMatch',
        message(error: any, field: FormlyFieldConfig) {
          return 'Mật khẩu không khớp';
        },
      },
      {
        name: 'noSpacesNoSpecial',
        message(error: any, field: FormlyFieldConfig) {
          return 'Không chưa kí tự đặc biệt và khoảng trắng';
        },
      },
      {
        name: 'required',
        message() {
          return 'Trường này là bắt buộc';
        },
      },
      {
        name: 'minLength',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream(field.props?.label || '').pipe(
            switchMap((_) =>
              translate.stream('FORM.VALIDATION.MIN', {
                field: field.props?.label,
                min: error.requiredLength,
              })
            )
          );
        },
      },
      {
        name: 'maxLength',
        message(error: any, field: FormlyFieldConfig) {
          return translate.stream(field.props?.label || '').pipe(
            switchMap((_) =>
              translate.stream('FORM.VALIDATION.MAX', {
                field: field.props?.label,
                max: error.requiredLength,
              })
            )
          );
        },
      },
    ] as ValidationMessageOption[],
  };
}
